import { observer } from 'mobx-react';
import React from 'react';
import { useI18n } from '@udemy/i18n';
import { useCareerAcceleratorsNavContent } from '../../../hooks/use-career-accelerator-nav-content';
import { MobileNavL2Nav, MobileNavSection, MobileNavSectionHeading } from '../mobile-nav.react-component';
/**
 * L2 (level-two) academies nav. Renders as a sub-drawer under "Find Courses" with back to L1.
 */
export const MobileAcademiesNavL2 = observer(() => {
  const {
    gettext
  } = useI18n();
  const {
    renderAcademiesNavItemList
  } = useCareerAcceleratorsNavContent();
  return /*#__PURE__*/React.createElement(MobileNavL2Nav, {
    id: "header-toggle-side-nav-academies-l2",
    l1NavId: "header-toggle-side-nav-find-courses",
    l1NavTitle: gettext('Find Courses'),
    mainBackItemTitle: gettext('Main Menu')
  }, /*#__PURE__*/React.createElement(MobileNavSectionHeading, null, gettext('In-demand Careers')), /*#__PURE__*/React.createElement(MobileNavSection, null, renderAcademiesNavItemList('l2')));
});
//# sourceMappingURL=mobile-academies-nav.react-component.js.map